import { useMutation, useQueryClient } from '@tanstack/react-query';
import { outfitService } from 'shared/src/api';
import type { GetRelatedOutfitListResponse } from 'shared/src/api/goodsService/getRelatedOutfits/types';
import { queryKey } from '../../../../../constant/queryKey';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';

export const useBookmarkOutfit = () => {
  const queryClient = useQueryClient();
  const goodsSno = useGoodsSno();

  return useMutation({
    mutationFn: ({
      sno,
      bookmarked,
    }: {
      sno: number;
      bookmarked: boolean;
    }) =>
      (bookmarked
        ? outfitService.removeBookmark(sno)
        : outfitService.postBookmark(sno)
      ).then(() => ({ sno, bookmarked: !bookmarked })),
    onSuccess: ({ sno, bookmarked }) => {
      queryClient.setQueryData<GetRelatedOutfitListResponse>(
        queryKey.goodsRelatedOutfit(goodsSno),
        oldData => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            item_list: oldData.item_list.map(outfit =>
              outfit.item.sno === sno
                ? {
                    ...outfit,
                    item: {
                      ...outfit.item,
                      bookmark: {
                        count:
                          outfit.item.bookmark.count + (bookmarked ? 1 : -1),
                        bookmarked,
                      },
                    },
                  }
                : outfit,
            ),
          };
        },
      );
    },
  });
};
